/*
  Project: Sharedpath
  Author: Jay Zambrano
 */
import InView from 'inview';
import BadgerAccordion from 'badger-accordion';
import tippy from 'tippy.js/dist/tippy-bundle.cjs.js';
import iframeResize from 'iframe-resizer';
import './modules/waloginbox';



var isOldIE = (navigator.userAgent.indexOf("MSIE") !== -1); // Detect IE10 and below


iFrameResize({
  log: false,                  // Enable console logging
  enablePublicMethods: true,                  // Enable methods within iframe hosted page
});



const accordions = document.querySelectorAll('.js-badger-accordion');

Array.from(accordions).forEach((accordion) => {
  const ba = new BadgerAccordion(accordion);

  // console.log(ba.getState([0]));
});

tippy('[data-tippy-content]', {
  theme: 'spci',
});

var header_img = document.getElementById('header_image');
var logo = document.getElementById('header_logo');
var topBar = document.getElementById('top_bar');
var headerInView = InView(header_img, function (isInView, data) {
  if (isInView) {
    console.log(data.elementOffsetTopInViewHeight);
    if (data.elementOffsetTopInViewHeight < topBar.offsetHeight - 100) {
      logo.classList.add('hidden');
      document.getElementById('top_icon').classList.add('visible');
      document.getElementById('top_search_box').classList.add('hidden');

      setTimeout(() => {
        document.getElementById('top_search_box').classList.add('d-none');
        document.getElementById('main-nav').classList.add('sticky');
      }, 10);
      document.getElementById('header-wrapper').style.marginTop = topBar.offsetHeight + 'px';



    }
    else {
      document.getElementById('top_icon').classList.remove('visible');
      document.getElementById('top_search_box').classList.remove('hidden');


      setTimeout(() => {
        document.getElementById('top_search_box').classList.remove('d-none');
        document.getElementById('main-nav').classList.remove('sticky');
        logo.classList.remove('hidden');
      }, 10);
      document.getElementById('header-wrapper').style.marginTop = "0";
    }

  }
  else {
    logo.classList.add('hidden');
    document.getElementById('top_icon').classList.add('visible');
    document.getElementById('top_search_box').classList.add('hidden');
    document.getElementById('header-wrapper').style.marginTop = topBar.offsetHeight + 'px';
    setTimeout(() => {
      document.getElementById('top_search_box').classList.add('d-none');
    }, 10);
  }
});



jQuery(document).on("click", "#search-btn", function () {
  if (jQuery(this).prop("checked") == true) {
    jQuery('.search_container input').focus();
  }
});

jQuery(document).on("click", ".mm-btn_close", function () {
  jQuery('#search-btn').prop('checked', false);
});



jQuery('.subject_options input').click(function () {
  jQuery('.subject_options input:not(:checked)').parent().removeClass("selected");
  jQuery('.subject_options input:checked').parent().addClass("selected");
});


jQuery('.send_a_copy input').click(function () {
  jQuery('.send_a_copy input:not(:checked)').parent().removeClass("selected");
  jQuery('.send_a_copy input:checked').parent().addClass("selected");
});



var subNavs = document.getElementsByClassName('menu-item-has-children');



Array.prototype.forEach.call(subNavs, function (el) {
  // Do stuff here
  
  var navBtn = document.getElementById('nav-' + el.dataset.id);
  var subNav = document.getElementById('sub-nav-' + el.dataset.id);
  if (navBtn){
  navBtn.addEventListener('click', e => {
    e.preventDefault();
    
    if(navBtn.classList.contains('open')){
      navBtn.classList.remove('open');
      subNav.style.display = "none";
    }
    else {
      jQuery('.c-main-nav__item span').removeClass('open');
      navBtn.classList.add('open');
      jQuery('.sub-nav-container ul').hide();
      subNav.style.display = "flex";
    }
   
  });
}

});



// WEBPACK FOOTER //
// ./src/scripts/app.js